/**
 * Detects the Next.js Server Action deploy-skew failure mode.
 *
 * A browser can hold a client bundle referencing a Server Action id baked
 * into a previous deploy. Once a newer Worker is live (this app zone deploys
 * frequently), that id is no longer recognized and Next.js throws
 * `UnrecognizedActionError` with a message like:
 *
 *   Server Action "607c8609fb81a7950333158c32e06c27929411a695" was not
 *   found on the server.
 *
 * Vercel has built-in skew protection for this; OpenNext on Cloudflare
 * Workers does not, so every Server Action call site on a long-lived,
 * client-rendered page (like /settings) must catch this explicitly and
 * point the user at a page refresh instead of failing silently/confusingly.
 */
export function isServerActionSkewError(error: unknown): boolean {
	if (!(error instanceof Error)) return false;
	return (
		error.name === "UnrecognizedActionError" ||
		/UnrecognizedActionError/i.test(error.message) ||
		/was not found on the server/i.test(error.message)
	);
}
